module.exports = __webpack_public_path__ + "static/media/payout-option_paypal.eb37c0f4.png";